import { useSelector } from "react-redux";
import { State } from "../../../state/store";
import { CareRecipientWithDataSyncInformation } from "../../../domain/care_recipient/CareRecipientWithDataSyncInformation";
import { User } from "../../../domain/user/User";
import { CareRecipientId } from "../../../domain/care_recipient/CareRecipientId";
import { CareRecipientName } from "../../../domain/care_recipient/CareRecipientName";
import { DateObject } from "../../../domain/fundamental/DateObject";
import { CareRecipientHouseId } from "../../../domain/care_recipient/CareRecipientHouseId";
import { UserId } from "../../../domain/user/UserId";
import { UserName } from "../../../domain/user/UserName";
import { UserEmail } from "../../../domain/user/UserEmail";
import { getUserAccountRoleFromValue } from "../../../domain/user/account/UserAccountRole";
import { ServiceProviderId } from "../../../domain/service_provider/ServiceProviderId";
import { DateTime } from "../../../domain/fundamental/DateTime";

export function useList() : AdminList {

    const list = useSelector((state: State) => state.adminList.list);
    if (!list || !list.length) return null;

    return list.map( item => {
        const careRecipient = item.careRecipient;
        const users = item.users;
        return {
            careRecipientWithDataSyncInfo: careRecipient ? CareRecipientWithDataSyncInformation.from(
                CareRecipientId.fromString(careRecipient.id),
                CareRecipientName.fromString(careRecipient.name),
                DateObject.fromString(careRecipient.birthday),
                careRecipient.dataSyncInformation?.houseId ? CareRecipientHouseId.fromString(careRecipient.dataSyncInformation.houseId) : null,
                careRecipient.dataSyncInformation?.serviceProviderId ? ServiceProviderId.fromString(careRecipient.dataSyncInformation.serviceProviderId) : null,
                careRecipient.dataSyncInformation?.dataSyncPeriod?.startTime ? DateTime.fromString(careRecipient.dataSyncInformation.dataSyncPeriod.startTime) : null,
                careRecipient.dataSyncInformation?.dataSyncPeriod?.endTime ? DateTime.fromString(careRecipient.dataSyncInformation?.dataSyncPeriod?.endTime) : null,
                null,
                null
            ) : null,
            users: users.map(user => {
                return User.from(
                    UserId.fromString(user.id),
                    UserName.fromString(user.name),
                    UserEmail.fromString(user.account.email),
                    getUserAccountRoleFromValue(user.account.role)
                );
            })
        };
    });
}

type AdminList = {
    careRecipientWithDataSyncInfo: CareRecipientWithDataSyncInformation | null,
    users: User[]
}[] | null